import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg md:text-xl font-medium rounded-full transition-all duration-300 shadow-soft hover:shadow-glow transform hover:-translate-y-1 text-center w-full md:w-auto';
  const variants = {
    primary: 'bg-deep-rose hover:bg-deep-rose-dark text-white',
    secondary: 'bg-white hover:bg-soft-rose text-warm-brown border border-soft-rose-dark'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-328">
      {children}
    </button>;
}